import { createSelector } from '@ngrx/store';

import type { InterviewResult } from '@core/interview-results-types';
import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  memoizeSelector,
  ngrxEvent,
} from '@core/ngrx-legacy';

import { EntityStoreKey } from '../types';

export const candidateScope = (id: number) => `candidate_${id}`;

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<InterviewResult>()(
  EntityStoreKey.hiddenEvaluations,
  {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id);

      return {
        fetchHiddenResults: (
          state,
          payload: { candidateId: number; offerId?: number; stageId?: number },
        ) => actions.fetchCollection(state, { scope: candidateScope(payload.candidateId) }),
        fetchHiddenResultsSuccess: actions.fetchCollectionSuccess,
        fetchHiddenResultsFailed: actions.fetchCollectionFailed,
        hiddenEvaluationsReviewClick: ngrxEvent<{
          candidateId: number;
          offerId?: number;
          stageId?: number;
        }>(),
      };
    },
  },
);

const selectCandidateScope = memoizeSelector((candidateId: number) =>
  createSelector(
    selectors.entities({ scope: candidateScope(candidateId) }),
    (results: InterviewResult[]) => results,
  ),
);

const customSelectors = {
  ...selectors,
  candidateScope: selectCandidateScope,
};

export {
  actions as HiddenResultsActions,
  reducer as HiddenResultsReducer,
  customSelectors as HiddenResultsSelectors,
  namespace as HiddenResultsNamespace,
};
